import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
	state: sessionStorage.getItem('state') ? JSON.parse(sessionStorage.getItem('state')) : {
		memberPageType: '',
		memberPageId: '',
		companyChangeId: '',
		signUpRecordId: '',
		studentId: '',
		editStudentId: "",
		nationList: [],
		token: '',
	},
	mutations: {
		setnationList(state, nationList) {
			state.nationList = nationList
		}
	},
	actions: {
		getNationList({commit}, nationList) {
			commit('setnationList', nationList);
		}
	},
	modules: {}
})
